import React, { useState } from "react";

import Box from "@material-ui/core/Box";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";

import HorseShoe from "components/Icons/HorseShoe";
import Dialog from "components/Dialog";
import Loader from "components/Loader";
import { useRacehorse360Api } from "hooks/api";
import { SortOrder } from "interfaces/SortOrder";
import { transformViewDate } from "utils/date-utils";

import useStyles from "./styles";

interface Props {
  horseId: string;
  horseName: string;
}

const HorseListsModal = (props: Props) => {
  const { horseId, horseName } = props;
  const classes = useStyles();

  const [isListsOpen, setIsListsOpen] = useState<boolean>(false);

  const { useListHorseOnLists } = useRacehorse360Api();

  const { data, isLoading } = useListHorseOnLists(
    {
      query: {
        horseId: { value: horseId },
        activeOnly: { value: true }
      },
      getOptions: {
        select: ["list_type", "date_on"],
        orderBy: [`dateOn ${SortOrder.ASC}`]
      }
    },
    {
      enabled: isListsOpen
    }
  );

  const horseOnLists = data?.horseOnLists || [];

  const handleHorseshoeClick = e => {
    e.stopPropagation();
    setIsListsOpen(true);
  };

  const handleListsClose = e => {
    e.stopPropagation();
    setIsListsOpen(false);
  };

  const handleDialogClick = e => e.stopPropagation();

  return (
    <div onClick={handleDialogClick}>
      <IconButton
        onClick={handleHorseshoeClick}
        className={classes.horseshoeButton}
        data-test-id={"horseshoeButton"}
      >
        <HorseShoe className={classes.horseShoe} />
      </IconButton>
      {isListsOpen && (
        <Dialog
          title={horseName}
          onClose={handleListsClose}
          titleClassName={classes.modalTitleClassName}
          className={classes.listsModal}
          isOpen={isListsOpen}
        >
          <DialogContent>
            <Typography component={"p"} className={classes.detailsDialogText}>
              Active List Activity
            </Typography>
            {isLoading ? (
              <Loader overlay />
            ) : (
              horseOnLists?.map(horseOnList => {
                return (
                  <Box key={horseOnList.id} className={classes.activityLine}>
                    <Box>{horseOnList.listType}</Box>
                    <Box className={classes.detailsDialogDate}>
                      {transformViewDate(horseOnList.dateOn, null, "M/d/yy")}
                    </Box>
                  </Box>
                );
              })
            )}
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default React.memo(HorseListsModal);
